import type {
  ApplicationStatus,
  ChecklistMarkedBy,
  ChecklistSection,
  CheckupStatus,
  CheckupTopic,
  StreamerStatus,
} from '@growup/streaming-shared';
import type { StatusTone } from '@growup/ui';

export const APPLICATION_LOOK: Record<ApplicationStatus, { label: string; tone: StatusTone }> = {
  pending: { label: 'Por decidir', tone: 'warning' },
  approved: { label: 'Aprovada', tone: 'success' },
  rejected: { label: 'Recusada', tone: 'neutral' },
  withdrawn: { label: 'Desistiu', tone: 'neutral' },
};

export const STREAMER_LOOK: Record<StreamerStatus, { label: string; tone: StatusTone }> = {
  active: { label: 'Ativo', tone: 'success' },
  paused: { label: 'Em pausa', tone: 'info' },
  removed: { label: 'Saiu', tone: 'neutral' },
};

export const LEVEL_LABEL: Record<string, string> = {
  user: 'Utilizador',
  member: 'Membro',
  associate: 'Associado',
};

export function formatMinutes(total: number): string {
  const m = Math.max(0, Math.round(total));
  const h = Math.floor(m / 60);
  return h > 0 ? `${String(h)}h${String(m % 60).padStart(2, '0')}` : `${String(m)} min`;
}

export const formatCount = (n: number) => n.toLocaleString('pt-PT');

export const CHECKUP_LOOK: Record<CheckupStatus, { label: string; tone: StatusTone }> = {
  ok: { label: 'Tudo bem', tone: 'success' },
  attention: { label: 'Precisa de atenção', tone: 'warning' },
  unreachable: { label: 'Não consegui falar', tone: 'danger' },
};

export const TOPIC_LABEL: Record<CheckupTopic, string> = {
  technical: 'Técnica',
  content: 'Conteúdo e ideias',
  motivation: 'Motivação',
  conduct: 'Conduta',
  other: 'Outro',
};

export const SECTION_LABEL: Record<ChecklistSection, string> = {
  welcome: 'Boas-vindas',
  padrinho: 'Conhecer o padrinho',
  brand: 'Marca Grow uP',
  technical: 'Técnica',
  streaming: 'Transmitir',
  closing: 'Fecho',
};

export const MARKED_BY_LABEL: Record<ChecklistMarkedBy, string> = {
  streamer: 'O streamer',
  padrinho: 'O padrinho',
  auto: 'Automático',
};
